<template>
  <div>
    <v-container fluid grid-list-lg class="pa-2" :style="{ width: '100% !important' }">
      <v-layout align-center wrap>
        <v-flex grow class="headline primary--text">Sentiment</v-flex>
        <v-flex shrink>
          <v-btn color="primary" @click="handleExportButtonClick">
            <v-icon>logout</v-icon>
            Export
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-data-table
      ref="dataTable"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      hide-actions
      disable-initial-sort
      :custom-sort="() => items"
      :pagination="pagination"
      @update:pagination="handleDataTablePaginationUpdate"
    >
      <template #items="{ item }">
        <td>{{ `${item.first_name} ${item.last_name}` }}</td>
        <td>{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm:ss') }}</td>
        <td>{{ item.pagename }}</td>
        <td>{{ item.post_id }}</td>
        <td>{{ item.message }}</td>
        <td>
          <SentimentMenu :value="item.sentiment" readonly />
        </td>
        <td class="text-xs-right">{{ item.total_nagative | totalNegativeDisplay }}</td>
        <td>
          <v-btn small flat icon color="primary" @click="() => view(item)">
            <v-icon>search</v-icon>
          </v-btn>
          <!-- <v-btn
            icon
            outline
            small
            color="primary"
            class="m-0"
            @click.stop="goToLivechat(item, item.app)"
          >
            <em class="fas fa-comments" />
          </v-btn> -->
        </td>
      </template>
    </v-data-table>

    <div class="mt-2" :style="{ display: 'flex' }">
      <v-pagination
        class="ml-auto"
        :length="totalPages"
        :value="pagination.page"
        @input="handlePaginationInput"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import SentimentMenu from './SentimentMenu.vue'

export default {
  components: {
    SentimentMenu
  },
  filters: {
    totalNegativeDisplay(value) {
      if (value === 0) return '-'
      return value
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // "user_id": "6738831219513401",
    // "first_name": "Oat",
    // "last_name": "Rawat",
    // "timestamp": "2023-09-04T09:29:28.542Z",
    // "post_id": "116388304732570_223977873930052",
    // "message": "ล่ม",
    // "sentiment": "nagative",
    // "total_nagative": "3"
    return {
      headers: [
        {
          text: 'Customer name',
          value: 'first_name',
          sortable: false
        },
        {
          text: 'Date & time',
          value: 'timestamp',
          sortable: false
        },
        {
          text: 'Page',
          value: 'pageid',
          sortable: false
        },
        {
          text: 'Post',
          value: 'post_id',
          sortable: false
        },
        {
          text: 'Message',
          value: 'message',
          sortable: false
        },
        {
          text: 'Last sentiment',
          value: 'sentiment',
          sortable: false
        },
        {
          text: 'Total negative',
          value: 'total_nagative',
          align: 'right'
        },
        {
          text: 'Action',
          sortable: false
        }
      ]
    }
  },
  computed: {
    totalPages() {
      const { totalItems = 0, rowsPerPage } = this.pagination
      return Math.ceil(totalItems / rowsPerPage)
    }
  },
  methods: {
    view(item) {
      this.$emit('view', item)
    },
    handleExportButtonClick() {
      this.$emit('export')
    },
    handleDataTablePaginationUpdate(value) {
      this.$emit('update:pagination', value)
    },
    handlePaginationInput(page) {
      this.$emit('update:pagination', { ...this.pagination, page })
    },
    goToLivechat: function (user, app) {
      const routeData = this.$router.resolve({
        name: 'livechat',
        path: `/${this.currentLang}/livechat`,
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/DataTable.vue